import { FooterComponent } from '@/shared/components/footer/footer.component';
import { HeaderComponent } from '@/shared/components/header/header.component';
import { TabsComponent } from '@/shared/components/tabs/tabs.component';
import { NgIfPhoneAndTabletDirective } from '@/shared/directives/ng-if-phone-and-tablet/ng-if-phone-and-tablet.directive';
import { MobileAppService } from '@/shared/services/mobile-app.service';
import { Component, inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CookiesComponent } from './shared/components/cookies/cookies.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService],
  standalone: true,
  imports: [
    RouterOutlet,
    ToastModule,
    DialogModule,
    MatDialogModule,
    FooterComponent,
    HeaderComponent,
    NgIfPhoneAndTabletDirective,
    TabsComponent,
  ],
})
export class AppComponent implements OnInit {
  private readonly mobileAppService = inject(MobileAppService);
  private readonly dialog = inject(MatDialog);

  get isMobileApp() {
    return this.mobileAppService.isMobileApp;
  }

  ngOnInit() {
    this.checkCookies();
  }

  /**
   * Accept COOKIES
   * ============================================
   */
  openCookiesDialog(): void {
    this.dialog.open(CookiesComponent, {
      disableClose: true,
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
    });
  }

  checkCookies() {
    if (!this.checkCookiesAccepted()) {
      this.openCookiesDialog();
    }
  }

  /**
   * Check if Cookies have been accepted
   */
  checkCookiesAccepted() {
    const cookiesAccepted = this.getCookieByName('cookiesAllowed');

    if (cookiesAccepted) {
      return true;
    }
    return false;
  }

  getCookieByName(cname: string) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
}
